/** Purpose: parse Retry-After as seconds or an HTTP date. Why: callers need a safe wait duration before retrying a rate-limited request. */
export function retryDelay(headers = {}, now = Date.now()) {
  const value = headers['retry-after'];
  if (value == null) return null;
  const seconds = Number(value);
  const delay = Number.isFinite(seconds) ? seconds * 1000 : Date.parse(value) - now;
  return Number.isFinite(delay) ? Math.max(0, delay) : null;
}

/** Purpose: add shared handling for HTTP 429 responses. Why: gives brief safe GET limits one retry while surfacing longer limits without replaying writes. */
export function installRateLimitRetry(client) {
  return client.interceptors.response.use((response) => response, async (error) => {
    if (error.response?.status !== 429) throw error;
    const config = error.config || {};
    const delay = retryDelay(error.response.headers);
    const message = delay == null
      ? 'Too many requests. Please wait and try again.'
      : `Too many requests. Please try again in ${Math.max(1, Math.ceil(delay / 1000))} seconds.`;
    error.message = message;
    error.response.data = { ...(typeof error.response.data === 'object' ? error.response.data : {}), error: message };
    // Never replay writes, chat sends or login actions. Long limits are surfaced
    // immediately instead of leaving a page loading for many minutes.
    if (String(config.method).toLowerCase() === 'get' && !config._rateLimitRetried && delay != null && delay <= 5000) {
      await new Promise((resolve) => setTimeout(resolve, Math.max(250, delay)));
      return client.request({ ...config, _rateLimitRetried: true });
    }
    throw error;
  });
}
